<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
            <template slot="header">
              <h4 class="card-title">Manual Payment Update</h4>
            </template>
            
            <b-row class="mb-4">
              <b-col md="6">
                <h5>Single Update</h5>
                <validation-observer ref="observer" v-slot="{ handleSubmit }">
                  <b-form class="text-left" @submit.stop.prevent="handleSubmit(singleUpdate)">
                    <b-row no-gutters>
                      <b-col md="12" style="justify-content: center; align-items: center">
                        <VinputGroup
                          inputType="text"
                          :modelValue="singleForm.phoneNumber"
                          @update:modelValue="(newValue) => (singleForm.phoneNumber = newValue)"
                          :rules="{ required: true, regex:/^\d{9}$/ }"
                          id="text-phoneNumber"
                          name="text-phoneNumber"
                          label="Phone Number"
                          prepend="+251"
                          class="mb-1 mr-sm-2"
                          description="text-phoneNumber-feedback"
                          validatorName="Phone Number"
                        />
                      </b-col>
                      <b-col md="12" style="justify-content: center; align-items: center">
                        <Vinput
                          inputType="text"
                          :modelValue="singleForm.fullName"
                          @update:modelValue="(newValue) => (singleForm.fullName = newValue)"
                          :rules="{ required: true, regex:/^[a-zA-Z\u1200-\u137F ]+$/ }"
                          id="text-fullName"
                          name="text-fullName"
                          label="Full Name"
                          class="mb-1 mr-sm-2"
                          description="text-fullName-feedback"
                          validatorName="Full Name"
                        />
                      </b-col>
                      <b-col md="12" style="justify-content: center; align-items: center">
                        <VinputNumber
                          :modelValue="singleForm.newManualAmount"
                          @update:modelValue="(newValue) => (singleForm.newManualAmount = Number(newValue) || 0)"
                          :rules="{ required: true, min_value: 0 }"
                          id="text-amount"
                          name="text-amount"
                          label="New Manual Amount"
                          class="mb-1 mr-sm-2"
                          description="text-amount-feedback"
                          validatorName="New Manual Amount"
                        />
                      </b-col>
                      <b-col class="mt-2">
                        <b-button type="submit" variant="primary" :disabled="loading">
                          <b-spinner v-if="loading" small></b-spinner>
                          Update Payment
                        </b-button>
                      </b-col>
                    </b-row>
                  </b-form>
                </validation-observer>
              </b-col>
              
              <b-col md="6">
                <h5>Bulk CSV Upload</h5>
                <b-row class="mb-3">
                  <b-col md="12" class="text-center">
                    <b-button variant="success" @click="downloadSample">
                      Download Sample CSV
                    </b-button>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="12">
                    <label>Upload CSV File</label>
                    <b-form-file
                      v-model="csvFile"
                      @change="handleFileUpload"
                      accept=".csv"
                      class="mb-2"
                    ></b-form-file>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="12">
                    <b-button
                      variant="primary"
                      @click="bulkUpdate"
                      :disabled="loading || !csvFile"
                    >
                      <b-spinner v-if="loading" small></b-spinner>
                      Bulk Update
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>

            <div v-if="results" class="mt-4">
              <h5>Update Results</h5>
              <b-row>
                <b-col md="6" v-if="results.successes && results.successes.length">
                  <b-alert show variant="success">
                    <h6>Successes ({{ results.successes.length }})</h6>
                    <ul class="mb-0">
                      <li v-for="success in results.successes" :key="success">{{ success }}</li>
                    </ul>
                  </b-alert>
                </b-col>
                <b-col md="6" v-if="results.errors && results.errors.length">
                  <b-alert show variant="danger">
                    <h6>Errors ({{ results.errors.length }})</h6>
                    <ul class="mb-0">
                      <li v-for="error in results.errors" :key="error">{{ error }}</li>
                    </ul>
                  </b-alert>
                </b-col>
              </b-row>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Card from 'src/components/Cards/Card.vue'
import Vinput from 'src/components/Inputs/Vinput.vue'
import VinputGroup from 'src/components/Inputs/VinputGroup.vue'
import VinputNumber from 'src/components/Inputs/VinputNumber.vue'

export default {
  name: 'ManualPaymentUpdate',
  components: {
    Card,
    Vinput,
    VinputGroup,
    VinputNumber
  },
  data() {
    return {
      loading: false,
      csvFile: null,
      results: null,
      singleForm: {
        phoneNumber: '',
        fullName: '',
        newManualAmount: 0
      }
    }
  },
  methods: {
    singleUpdate() {
      this.$bvModal.msgBoxConfirm('Are you sure you want to update this payment?', {
        title: 'Confirm',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'success',
        cancelVariant: 'danger',
        okTitle: 'YES',
        cancelTitle: 'NO',
        bodyClass: 'm-2',
        hideHeaderClose: false,
        centered: false
      })
      .then(value => {
        if (value === true) {
          this.loading = true
          this.results = null
          
          const formData = {
            ...this.singleForm,
            phoneNumber: '+251' + this.singleForm.phoneNumber
          }
          this.$store.dispatch('bulkUpdateManualPayments', [formData])
          .then(response => {
            this.results = response.data
            this.$notifications.notify({
              message: 'Payment updated successfully',
              horizontalAlign: 'center',
              verticalAlign: 'top',
              type: 'success'
            })
            this.clearSingleForm()
          })
          .catch(error => {
            this.$notifications.notify({
              message: (error.response && error.response.data) || 'Update failed',
              horizontalAlign: 'center',
              verticalAlign: 'top',
              type: 'danger'
            })
          })
          .finally(() => {
            this.loading = false
          })
        }
      })
      .catch(error => {
        console.log(error)
      })
    },

    bulkUpdate() {
      if (!this.csvFile) return
      
      this.$bvModal.msgBoxConfirm('Are you sure you want to perform bulk update?', {
        title: 'Confirm',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'success',
        cancelVariant: 'danger',
        okTitle: 'YES',
        cancelTitle: 'NO',
        bodyClass: 'm-2',
        hideHeaderClose: false,
        centered: false
      })
      .then(value => {
        if (value === true) {
          this.loading = true
          this.results = null
          
          this.parseCsvFile(this.csvFile)
          .then(csvData => {
            return this.$store.dispatch('bulkUpdateManualPayments', csvData)
          })
          .then(response => {
            this.results = response.data
            this.$notifications.notify({
              message: 'Bulk update completed',
              horizontalAlign: 'center',
              verticalAlign: 'top',
              type: 'success'
            })
            this.csvFile = null
          })
          .catch(error => {
            this.$notifications.notify({
              message: (error.response && error.response.data) || 'Bulk update failed',
              horizontalAlign: 'center',
              verticalAlign: 'top',
              type: 'danger'
            })
          })
          .finally(() => {
            this.loading = false
          })
        }
      })
      .catch(error => {
        console.log(error)
      })
    },

    handleFileUpload(file) {
      this.csvFile = file
    },

    parseCsvFile(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = (e) => {
          try {
            let csv = e.target.result
            // Remove UTF-8 BOM if present
            if (csv.charCodeAt(0) === 0xFEFF) {
              csv = csv.slice(1)
            }
            const lines = csv.split('\n')
            
            const data = lines.slice(1)
              .filter(line => line.trim())
              .map(line => {
                const values = line.split(',').map(v => v.trim().replace(/"/g, ''))
                let phoneNumber = values[0]
                // Remove leading 0 if present and add +251 prefix
                phoneNumber = '+251' + phoneNumber.replace(/^0/, '')
                return {
                  phoneNumber: phoneNumber,
                  fullName: values[1],
                  newManualAmount: parseFloat(values[2]) || 0
                }
              })
            
            resolve(data)
          } catch (error) {
            reject(new Error('Invalid CSV format'))
          }
        }
        reader.onerror = () => reject(new Error('Failed to read file'))
        reader.readAsText(file, 'UTF-8')
      })
    },

    downloadSample() {
      const sampleData = [
        ['phoneNumber', 'fullName', 'newManualAmount'],
        ['911111111', 'ጆን ዶ', '1000.00'],
        ['912121212', 'ጄን ስሚዝ', '1500.50']
      ]
      
      // Add UTF-8 BOM for proper Amharic character support
      let csvContent = '\ufeff'
      sampleData.forEach((rowArray) => {
        const row = rowArray.map(field => `"${field}"`).join(',')
        csvContent += row + '\r\n'
      })
      
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8' })
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.setAttribute('href', url)
      link.setAttribute('download', 'manual_payment_sample.csv')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    },

    clearSingleForm() {
      this.singleForm = {
        phoneNumber: '',
        fullName: '',
        newManualAmount: 0
      }
    }
  }
}
</script>

<style scoped>
.content {
  padding: 20px;
}

.form-group {
  margin-bottom: 1rem;
}

.form-group label {
  font-weight: 600;
  margin-bottom: 0.5rem;
  display: block;
}

.form-control {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.btn {
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.btn-primary {
  background-color: #007bff;
  color: white;
}

.btn-success {
  background-color: #28a745;
  color: white;
}

.btn-info {
  background-color: #17a2b8;
  color: white;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.alert {
  padding: 1rem;
  border-radius: 4px;
  margin-bottom: 1rem;
}

.alert-success {
  background-color: #d4edda;
  color: #155724;
}

.alert-danger {
  background-color: #f8d7da;
  color: #721c24;
}

.mb-0 {
  margin-bottom: 0;
}

.mb-3 {
  margin-bottom: 1rem;
}

.mb-4 {
  margin-bottom: 1.5rem;
}

.mt-4 {
  margin-top: 1.5rem;
}
</style>